<div class="mb-5">
	<app-daily-utilization-chart
		*ngIf="data"
		[chart]="chart"
		[title]="'utilization.daily_charger_fleet_utilization' | translate"
		[tooltipText]="'chargLinkDevice.daily_fleet_utilization'"
		[vAxisTitle]="'site.number_of_charger' | translate"
	></app-daily-utilization-chart>
</div>
